<template>
	<div :class="mergedClass">
		<Button v-if="!disableBackBtn" :class="buttonClass" @click="onBack" variant="tertiary">
			<span class="fi fi-sr-angle-small-left text-2xl flex"></span>
		</Button>
		<div v-if="title" class="text-xl leading-7 font-bold text-ellipsis overflow-hidden whitespace-nowrap">
			{{ title }}
		</div>
		<Button v-if="share" :class="buttonClass" @click="onShare" variant="tertiary">
			<span class="fi fi-sr-share text-2xl flex"></span>
		</Button>
	</div>
</template>
<script setup lang="ts">
import { twMerge } from 'tailwind-merge'

const {
	backLink,
	title,
	border = true,
	absolute,
	share,
	disableBackBtn,
	shareTitle,
	shareText,
} = defineProps<{
	backLink?: string
	title?: string
	border?: boolean
	share?: boolean
	absolute?: boolean
	disableBackBtn?: boolean
	shareTitle?: string
	shareText?: string
}>()

const attrs = useAttrs()
const router = useRouter()
const { $utils } = useNuxtApp()

const mergedClass = computed(() =>
	twMerge(
		'flex gap-2 items-center px-4',
		border ? 'border-b border-brand-neutral-3' : '',
		absolute ? 'absolute border-none w-full py-6' : 'py-3.5',
		share ? 'justify-between' : '',
		attrs.class as string
	)
)

const buttonClass = computed(() => twMerge('!p-0 rounded-full', absolute ? 'w-12 h-12' : 'h-8 w-8'))

const onShare = () => {
	const currentUrl = window.location.href

	/**
	 * @todo Make the title dynamic
	 */
	$utils.share({
		title: shareTitle || 'Compartilhar',
		text: shareText || 'Veja o que encontrei',
		url: currentUrl,
	})
}

const onBack = () => {
	if (backLink) {
		navigateTo(backLink)
	} else {
		router.back()
	}
}
</script>
